import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useRelatedNewsQuery } from '../hooks/useNewsListQuery';
import '../styles/RelatedNewsSlider.css';
import NewsImage from '../components/NewsImage';
import { trackEvent } from '../amplitude';

const RelatedNewsSlider = ({ currentNews, title = 'Читайте також' }) => {
  const location = useLocation();
  const { news: relatedNews } = useRelatedNewsQuery(currentNews, 12);

  if (!relatedNews.length) return null;

  return (
    <div className="related-news-block">
      <div className="related-news-head">
        <h3>{title}</h3>
      </div>

      <div className="related-news-scroll">
        {relatedNews.map((item, index) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            state={{ from: location.pathname + location.search }}
            className="related-news-card"
            onClick={() => trackEvent('related_news_clicked', {
              source_news_id: currentNews.id,
              target_news_id: item.id,
              position: index + 1,
              source_category: currentNews.category || null,
              target_category: item.category || null,
            })}
          >
            <div className="related-news-image-wrap">
              <NewsImage
                news={item}
                alt={item.title}
                className="related-news-image"
                loading="lazy"
              />
            </div>

            <div className="related-news-content">
              <div className="related-news-date">
                {item.day}.{item.month}.{item.year} {item.time}
              </div>

              <div className="related-news-title">
                {item.title}
              </div>

              <div className="related-news-footer">
                <div className="related-news-category">
                  {Array.isArray(item.sections) && item.sections.length > 0
                    ? item.sections[0]
                    : item.category}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedNewsSlider;
